module.exports = __webpack_public_path__ + "static/media/arrive-icon@2x.32d960d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/arrive-icon@2x.png
// module id = 1017
// module chunks = 0